import { createSelector } from 'reselect';
import { every, groupBy, isFinite, sumBy } from 'lodash';

export const getExternalInvestments = (state) =>
  state.externalInvestmentBalances;
function groupBalanceTotal(accountsInInstitutionGroup) {
  return sumBy(accountsInInstitutionGroup, (account) => {
    const { details: { balance: { balanceValue } = {} } = {} } = account;
    return balanceValue || 0.0;
  });
}

function buildExternalAccountDetails(accounts) {
  return accounts.map((account) => {
    const {
      accountName,
      accountNumber,
      accountStatus,
      balanceValue,
      balanceAsOfDate,
      institutionName,
      lastSuccessfulUpdateDate
    } = account;

    return {
      details: {
        account: {
          accountName,
          accountNumber,
          institutionName,
          lastSuccessfulUpdateDate,
          accountStatus
        },
        balance: {
          balanceValue,
          accountStatus,
          balanceAsOfDate
        }
      }
    };
  });
}

export const getErrorInfo = () => {
  let errorInfo = null;
  // this was originally used to map errors removed when yodlee stopped sending meaningful error codes. Can potentially be removed from component now
  return { errorInfo };
};

export const getExternalInvestmentsBalances = createSelector(
  getExternalInvestments,
  (filteredInvestments) => {
    // all accounts error - Title Level Error
    const allExternalAccountsError = every(
      filteredInvestments,
      (i) => i.accountStatus !== 0 || !isFinite(i.balanceValue)
    );

    return Object.values(groupBy(filteredInvestments, 'institutionName')).map(
      (accountsInGroup) => {
        const accountsInInstitutionGroup =
          buildExternalAccountDetails(accountsInGroup);
        const accountsBalance = groupBalanceTotal(accountsInInstitutionGroup);

        const { errorInfo } = getErrorInfo(accountsInGroup);

        const detailsInstitutionInfo = {
          groupLabel: accountsInGroup[0].institutionName
        };

        return {
          details: {
            name: detailsInstitutionInfo,
            balanceValue: accountsBalance,
            allExternalAccountsError,
            errorType: errorInfo ? errorInfo.status : null,
            errorMessage: errorInfo ? errorInfo.message : null
          },
          children: accountsInInstitutionGroup
        };
      }
    );
  }
);
